import { Link, Outlet, useLocation } from "react-router-dom";
import { Users, ShieldCheck, Sparkles } from "lucide-react";
import { useSettings } from "@/contexts/SettingsContext";
import { resolveUploadUrl } from "@/lib/api";

const AppShell = () => {
  const { pathname } = useLocation();
  const { settings } = useSettings();

  const tabs = [
    { to: "/uye", label: "Üye Etkinlik Bildirim", icon: Users, testid: "nav-member-tab" },
    { to: "/yonetici", label: "Yönetici Paneli", icon: ShieldCheck, testid: "nav-admin-tab" },
  ];

  return (
    <div className="min-h-screen pattern-ornament">
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[#F9F6F0]/85 border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Link to="/uye" className="flex items-center gap-4 group" data-testid="brand-link">
            {settings.logo_url ? (
              <img
                src={resolveUploadUrl(settings.logo_url)}
                alt={settings.site_name}
                data-testid="brand-logo"
                className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl object-cover shadow-md ring-2 ring-[#D4AF37]/40 bg-white"
              />
            ) : (
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-2xl flex items-center justify-center bg-[#8A252C] text-[#F9F6F0] shadow-md ring-2 ring-[#D4AF37]/40">
                <Sparkles className="w-9 h-9 sm:w-10 sm:h-10" strokeWidth={1.75} />
              </div>
            )}
            <div className="leading-tight">
              <div className="font-display text-3xl sm:text-4xl font-bold text-[#1F2937] tracking-tight" data-testid="brand-name">
                {settings.site_name}
              </div>
              <div className="text-xs uppercase tracking-[0.22em] text-[#8A252C]/80 font-semibold mt-1" data-testid="brand-subtitle">
                {settings.site_subtitle}
              </div>
            </div>
          </Link>

          <nav className="flex gap-2 p-1 bg-white/70 rounded-full border border-stone-200 shadow-sm" data-testid="main-nav">
            {tabs.map((tab) => {
              const active = pathname.startsWith(tab.to);
              const Icon = tab.icon;
              return (
                <Link
                  key={tab.to}
                  to={tab.to}
                  data-testid={tab.testid}
                  className={`relative px-4 sm:px-5 py-2 rounded-full text-sm font-medium flex items-center gap-2 transition-colors ${
                    active
                      ? "bg-[#8A252C] text-[#F9F6F0] shadow"
                      : "text-[#4B5563] hover:text-[#8A252C]"
                  }`}
                >
                  <Icon className="w-4 h-4" strokeWidth={2} />
                  <span className="hidden sm:inline">{tab.label}</span>
                  <span className="sm:hidden">{tab.label.split(" ")[0]}</span>
                </Link>
              );
            })}
          </nav>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-8 lg:py-12">
        <Outlet />
      </main>

      <footer className="border-t border-stone-200/70 mt-16">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-[#4B5563] flex flex-col sm:flex-row items-center justify-between gap-2">
          <div data-testid="footer-text">{settings.footer_text}</div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A252C]/70" data-testid="footer-tagline">
            {settings.footer_tagline}
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AppShell;
